import { render, staticRenderFns } from "./rExplicacionIa.vue?vue&type=template&id=9e6a2150&scoped=true"
import script from "./rExplicacionIa.vue?vue&type=script&lang=js"
export * from "./rExplicacionIa.vue?vue&type=script&lang=js"
import style0 from "./rExplicacionIa.vue?vue&type=style&index=0&id=9e6a2150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6a2150",
  null
  
)

export default component.exports